import React from 'react';
import styled from 'styled-components';
import ReceiptAsset from '../../images/receipt.svg';

const ContentWrapper = styled.div`
    display: block;
    text-align:left;
    width:95%;
`;

const ImageStyled  = styled.img`
  display: block;
  width: ${props => props.width};
  margin-left: auto;
  margin-right: auto;
`;


const PopoverContentAssembly = (props) => {
    const defaultTopOfReceiptFindRestaurantNo = 'Look at the top of your receipt to find your restaurant number.';

    return (
        <ContentWrapper>
            {props.getLocalizedText('TopOfReceiptFindRestaurantNo', defaultTopOfReceiptFindRestaurantNo)}
            <ImageStyled src={ReceiptAsset} alt="Wendy's Receipt" width={'95%'} />
        </ContentWrapper>
    );
};

export default PopoverContentAssembly;



// WEBPACK FOOTER //
// ./src/components/PopoverContentAssembly/index.js